<template>
<section
  :style="labelStyle"
  class="label-box"
>
  <slot>
    <span>{{label}}</span>
  </slot>
</section>
</template>

<script>
import labelBorder from 'assets/svg/label-maker/label-maker-border.svg';
import labelBorderWhite from 'assets/svg/label-maker/label-maker-border-white.svg';

export default {
  props: {
    white: Boolean,
    label: String,
    height: {
      type: Number,
      default: () => 46
    },
    width: {
      type: Number,
      default: () => 170
    }
  },
  computed: {
    labelStyle() {
      return {
        backgroundImage: this.white ? this.cardBorderWhite : this.cardBorder,
        height: `${this.height}px`,
        width: `${this.width}px`
      };
    }
  },
  data() {
    return {
      cardBorder: `url('data:image/svg+xml;utf8,${labelBorder}')`,
      cardBorderWhite: `url('data:image/svg+xml;utf8,${labelBorderWhite}')`
    };
  }
};
</script>
<style lang="scss" scoped>
* {
  box-sizing: border-box;
}
.label-box {
  background-repeat: no-repeat;
  background-size: 100% 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 0 10px;
}
</style>
